import { Base, withDrag } from "@studiometa/js-toolkit";
class ResizableCursor extends withDrag(Base) {
  /**
   * Config.
   */
  static config = {
    name: "ResizableCursor",
    options: {
      axis: {
        type: String,
        default: "x"
      }
    }
  };
  onPointerdown() {
    document.documentElement.classList.add("is-resizing");
  }
  onPointerup() {
    document.documentElement.classList.remove("is-resizing");
  }
}
export {
  ResizableCursor as default
};
//# sourceMappingURL=ResizableCursor.js.map
